import React, { useState, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import ThemeProvider from '../theme/wrappers';
import AppRouter from '../routes/app.routes';
import {
  checkAdminUserLoggedIn,
  setAdminUserLoggedOut,
  setAdminUserLoggedIn,
} from '../utils/local-cache.util';
import { adminUserValidateSession } from '../services/auth.service';
import Loader from '../components/common/loader.component';
import { getDataList } from '../services/content.service';
import RootLayout from '../layout/root.layout';

const AppView = () => {
  const [appLoaded, setAppLoaded] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [categoriesTab, setCategoriesTab] = useState([]);
  const [counter, setCounter] = useState(0);

  const rerenderComponent = () => {
    setCounter(counter + 1);
  };

  useEffect(() => {
    getDataList('tabs')
      .then((res) => {
        setCategoriesTab(res.data?.rows);
      })
      .catch(() => {
        // to do
      });
  }, [counter]);

  useEffect(() => {
    const isAdminLoggedIn = checkAdminUserLoggedIn();
    if (isAdminLoggedIn) {
      adminUserValidateSession()
        .then((res) => {
          const loggedInUserPayload = {
            token: res.data?.auth?.token || '',
            name: res.data?.name || '',
            email: res.data?.email || '',
            role: res.data?.role || '',
          };
          setAdminUserLoggedIn(loggedInUserPayload);
          setIsLoggedIn(isAdminLoggedIn);
          setAppLoaded(true);
        })
        .catch(() => {
          setAdminUserLoggedOut();
          setAppLoaded(true);
        });
    } else {
      setAppLoaded(true);
    }
  }, []);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <ThemeProvider>
          {!appLoaded && <Loader />}
          {appLoaded && (
            <RootLayout isLoggedIn={isLoggedIn} categoriesTab={categoriesTab}>
              <AppRouter
                isLoggedIn={isLoggedIn}
                categoriesTab={categoriesTab}
                rerenderComponent={rerenderComponent}
              />
            </RootLayout>
          )}
        </ThemeProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
};

export default AppView;
